import { baseURL } from "tinymce";

export default {
  // 超时
  timeout: 5 * 60 * 1000,
  baseURL: 'https://api.bpshe.com/',
  // baseURL: '/mall',
  // 是否支持跨域
  crossDomain: true,
  // 跨域带上cookie
  withCredentials: true,
  // 请求头，默认是采用application/json
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
}
